export const USERS_VERIFY_EVENTS = {
    REQUEST_SUMSUB_ACCESS_TOKEN: 'request_sumsub_access_token',
    RESPONSE_SUMSUB_ACCESS_TOKEN: 'response_sumsub_access_token',
}

export type TUsersVerifyEvents = typeof USERS_VERIFY_EVENTS[keyof typeof USERS_VERIFY_EVENTS];

export const USERS_VERIFY_STATUSES = {
    MANUAL_ERROR: 'manual_error',
    MANUAL_EXPIRED: 'manual_expired',
    MANUAL_PENDING: 'manual_pending',
    MANUAL_REJECTED: 'manual_rejected',
    MANUAL_REQUESTED: 'manual_requested',
    MANUAL_VERIFIED: 'manual_verified',
    NONE: 'none',
    SUMSUB_ERROR: 'sumsub_error',
    SUMSUB_EXPIRED: 'sumsub_expired',
    SUMSUB_PENDING: 'sumsub_pending',
    SUMSUB_REJECTED: 'sumsub_rejected',
    SUMSUB_REQUESTED: 'sumsub_requested',
    SUMSUB_VERIFIED: 'sumsub_verified',
} as const;

export type TUsersVerifyStatus = typeof USERS_VERIFY_STATUSES[keyof typeof USERS_VERIFY_STATUSES];
export type TUsersVerifyType = 'manual' | 'sumsub';

export interface IUserVerify {
    verified?: boolean;
    verified_at?: string;
    verify_status?: TUsersVerifyStatus;
    verify_type?: TUsersVerifyType;
    sumsub_access_token?: string;
}
